import axios from "axios";
import { DEFAULT_URL } from "./DEFAULT_URL";

export default axios.create({
  withCredentials: true,
  baseURL: DEFAULT_URL,
  headers: {
    "Content-type": "application/json",
  },
  timeout: 600_000, // fail if no response in 10*60*1000 s
});

//axios.defaults.withCredentials = true;
